import * as Yup from 'yup';
import { SendTicket } from 'src/models/FundraisingModel';
import { t } from 'src/lib/language';

const FundraisingTicketingValidator = (lang: string) => Yup.object().shape({
  title: Yup.string()
    .required(t(lang, 'validations.fundraising.ticketing.title_required')),
  event_date: Yup.date()
    .required(t(lang, 'validations.fundraising.ticketing.event_date_required')),
  location_name: Yup.string()
    .required(t(lang, 'validations.fundraising.ticketing.location_name_required')),
  location_address: Yup.string()
    .required(t(lang, 'validations.fundraising.ticketing.location_address_required')),
  contact_name: Yup.string()
    .nullable(),
  contact_phone: Yup.string()
    .nullable(),
  contact_email: Yup.string()
    .nullable()
    .email(t(lang, 'validations.fundraising.ticketing.contact_email_invalid')),
  ticket_send_mode: Yup.string()
    .oneOf(
      Object.values(SendTicket),
      t(lang, 'validations.fundraising.ticketing.ticket_send_mode_invalid'),
    )
    .required(t(lang, 'validations.fundraising.ticketing.ticket_send_mode_required')),
});

export default FundraisingTicketingValidator;
